<form class="form-container" [formGroup]="form">
  @if (f['complaintCategoryId'].value != null) {
      <h2 mat-dialog-title>{{'UPDATE_COMPLAINT_SUBTYPE' | translate}}</h2>

  } @else {
      <h2 mat-dialog-title>{{'ADD_COMPLAINT_SUBTYPE' | translate}}</h2>
      }
  <mat-dialog-content class="mat-typography">
      <mat-form-field appearance="outline">
          <mat-label>{{'COMPLAINT_TYPE' | translate}} </mat-label>
          <mat-select formControlName="complaintParentCategoryId">
              <!-- Input field for searching -->
              <input id="search-select" class="w-100 border-0 p-1" (input)="filteredListCategory=onFilteredListSearch($event, complainCategoryList, 'name')"
               placeholder="Search {{ 'COMPLAINT_TYPE' | translate }}" />
              @for (complainType of filteredListCategory;track complainType) {
              <mat-option [value]="complainType.complaintCategoryId">{{complainType.name}}</mat-option>
              }
          </mat-select>
          @if (f['complaintParentCategoryId'].errors) {
          <mat-error>
              @if (f['complaintParentCategoryId'].errors['required']) { <span>{{'COMPLAINT_TYPE_REQUIRED' |
                  translate}}</span>}
          </mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
          <mat-label>{{'NAME' | translate}} </mat-label>
          <input matInput formControlName="name">
          @if (f['name'].errors) {
          <mat-error>
              @if (f['name'].errors['required']) { <span>{{'NAME_REQUIRED' | translate}}</span>}
              @if (f['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
          </mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
          <mat-label>{{'DESCRIPTION' | translate}} </mat-label>
          <input matInput formControlName="description">
          @if (f['description'].errors) {
          <mat-error>
              @if (f['description'].errors['required']) { <span>{{'DESCRIPTION_REQUIRED' | translate}}</span>}
              @if (f['description'].errors['maxlength']) { <span>{{'MAX_LENGTH_300' | translate}}</span>}
          </mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
          <mat-label>{{'DAYS_REQUIRED' | translate}} </mat-label>
          <input matInput type="number" formControlName="complaintResolutionPeriod">
          @if (f['complaintResolutionPeriod'].errors) {
          <mat-error>
              @if (f['complaintResolutionPeriod'].errors['required']) { <span>{{'DAYS_REQUIRED' |
                  translate}}</span>}
          </mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
          <mat-label>{{'LEGAL_FRAMEWORK' | translate}} </mat-label>
          <input matInput type="text" formControlName="legalFramework">
      </mat-form-field>
      <mat-form-field appearance="outline">
          <mat-label>WhatsApp Name (English)</mat-label>
          <input matInput formControlName="whatsappNameEnglish" maxlength="24">
          <mat-hint align="end">{{f['whatsappNameEnglish'].value?.length || 0}}/24</mat-hint>
          @if (f['whatsappNameEnglish'].errors) {
          <mat-error>
              @if (f['whatsappNameEnglish'].errors['required']) { <span>Required</span> }
              @if (f['whatsappNameEnglish'].errors['minlength']) { <span>Min 5 characters</span> }
              @if (f['whatsappNameEnglish'].errors['maxlength']) { <span>Max 24 characters</span> }
          </mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
          <mat-label>WhatsApp Name (Urdu)</mat-label>
          <input matInput formControlName="whatsappNameUrdu" maxlength="24">
          <mat-hint align="end">{{f['whatsappNameUrdu'].value?.length || 0}}/24</mat-hint>
          @if (f['whatsappNameUrdu'].errors) {
          <mat-error>
              @if (f['whatsappNameUrdu'].errors['required']) { <span>Required</span> }
              @if (f['whatsappNameUrdu'].errors['minlength']) { <span>Min 5 characters</span> }
              @if (f['whatsappNameUrdu'].errors['maxlength']) { <span>Max 24 characters</span> }
          </mat-error>
          }
      </mat-form-field>

      <div class="row">
        <div class="col-md-3 col-12">
          <div class="form-group">
            <mat-label>{{ 'SEGMENT' | translate }}</mat-label>
            <br />
            <mat-checkbox formControlName="pulse" (change)="onPulseChange($event.checked)">PULSE</mat-checkbox>
            <mat-checkbox formControlName="plra" (change)="onPlraChange($event.checked)">PLRA</mat-checkbox>
          </div>
        </div>
      
        <mat-form-field appearance="outline">
          <mat-label>Default User Assignee</mat-label>
          <mat-select formControlName="defaultUserId" [disabled]="!form.value.pulse && !form.value.plra">
            <input
              id="search-user"
              class="w-100 border-0 p-1"
              (input)="filteredUserList = onFilteredListSearch($event, userManagementList, 'userName')"
              placeholder="Search {{ 'DEFAULT_USER' | translate }}"
            />
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let user of filteredUserList" [value]="user.defaultUserId">
              {{ user.userName }}
            </mat-option>
          </mat-select>
           @if (f['defaultUserId'].errors) {
          <mat-error>
              @if (f['defaultUserId'].errors['required']) { <span>{{'Default Assignee Required' |
                  translate}}</span>}
          </mat-error>
          }
        </mat-form-field>
      
        <mat-form-field appearance="outline">
          <mat-label>Default Group</mat-label>
          <mat-select formControlName="defaultAssigneeGroup" [disabled]="!form.value.pulse && !form.value.plra">
            <mat-option [value]="null">None</mat-option>
            <input
              id="search-group"
              class="w-100 border-0 p-1"
              (input)="filteredGroupList = onFilteredListSearch($event, groupList, 'name')"
              placeholder="Search {{ 'DEFAULT_GROUP' | translate }}"
            />
            <mat-option *ngFor="let group of filteredGroupList" [value]="group.defaultAssigneeGroup">
              {{ group.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      
        @if (isParentPublic) {
        <div class="col-md-3 col-12">
          <div class="form-group">
            <mat-label>{{ 'PUBLIC_COMPLAINT' | translate }}</mat-label>
            <br />
            <mat-checkbox formControlName="isPublic">{{ 'PUBLIC' | translate }}</mat-checkbox>
          </div>
        </div>
        }
      </div>
      

  </mat-dialog-content>
  <mat-dialog-actions align="end">
      <button
        mat-button
        class="btn-primary"
        [disabled]="form.invalid"
        *ngIf="f['complaintCategoryId'].value != null"
        (click)="edit()"
        color="primary"
        cdkFocusInitial>
        {{ 'Save' | translate }}
      </button>
      <button
        mat-button
        class="btn-primary"
        [disabled]="form.invalid"
        *ngIf="f['complaintCategoryId'].value == null"
        (click)="add()"
        color="primary"
        cdkFocusInitial>
        {{ 'Add_BUTTON' | translate }}
      </button>
      <button mat-button class="btn-secondary" mat-dialog-close>{{ 'Cancel' | translate }}</button>
    </mat-dialog-actions>
    
</form>
